import { createSlice } from '@reduxjs/toolkit'
import api from 'api/axios/foka'
import { createAxiosThunk } from 'utils/reduxUtil'

const initialState = {
  documents: [],
  page: 0,
  size: 10,
  total: 0,
  loading: true,
  error: null,
}

export const fetchDocuments = createAxiosThunk(
  'documentList/fetchDocuments',
  (noArgs, { getState }) => {
    const {
      documentList: { page, size },
    } = getState().document
    return api.document.getDocuments({ page, size })
  }
)

export const fetchDocumentsCount = createAxiosThunk(
  'documentList/fetchDocumentsCount',
  () => api.document.getDocumentsCount()
)

export const deleteDocument = createAxiosThunk(
  'documentList/deleteDocument',
  reviewDocumentId => api.document.deleteDocument(reviewDocumentId)
)

const documentListSlice = createSlice({
  name: 'documentList',
  initialState,

  reducers: {
    reset: () => initialState,
    setPage: (state, { payload: page }) => {
      state.page = page
    },
    setSize: (state, { payload: size }) => {
      state.size = size
    },
  },

  extraReducers: builder => {
    builder.addCase(fetchDocuments.pending, state => {
      state.loading = true
    })

    builder.addCase(fetchDocuments.fulfilled, (state, { payload }) => {
      state.documents = payload.content.map(
        ({
          id,
          name,
          siteUrl: { pcUrl, mobileUrl },
          reviewDocuments,
          bizChannelCategory,
        }) => {
          const creativeDocumentFiles = reviewDocuments.filter(
            d => d.reviewDocumentType === 'CREATIVE'
          )
          const channelDocumentFiles = reviewDocuments.filter(
            d => d.reviewDocumentType === 'BIZ_CHANNEL'
          )

          return {
            channelId: id,
            channelName: name,
            categoryFullPath: bizChannelCategory.categoryFullPath,
            siteUrl: {
              mobileUrl:
                mobileUrl &&
                `${mobileUrl.protocol.toLowerCase()}://${mobileUrl.url}`,
              pcUrl: pcUrl && `${pcUrl.protocol.toLowerCase()}://${pcUrl.url}`,
            },
            creativeDocuments: {
              files: creativeDocumentFiles,
              lastUpdateDate:
                creativeDocumentFiles.length > 0
                  ? creativeDocumentFiles
                      .map(file => file.createdDate)
                      .reduce((latest, curr) =>
                        Date.parse(latest) > Date.parse(curr) ? latest : curr
                      )
                  : null,
            },
            channelDocuments: {
              files: channelDocumentFiles,
              lastUpdateDate:
                channelDocumentFiles.length > 0
                  ? channelDocumentFiles
                      .map(file => file.createdDate)
                      .reduce((latest, curr) =>
                        Date.parse(latest) > Date.parse(curr) ? latest : curr
                      )
                  : null,
            },
          }
        }
      )
      state.total = payload.totalElements
      state.loading = false
    })

    builder.addCase(fetchDocuments.rejected, (state, { payload }) => {
      state.error = payload || true
      state.loading = false
    })

    builder.addCase(fetchDocumentsCount.fulfilled, (state, { payload }) => {
      state.documentsCount = payload.count
    })
  },
})

export const { reset, setPage, setSize } = documentListSlice.actions

export default documentListSlice.reducer
